import { VueMaskDirective } from 'v-mask'
import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('mask', VueMaskDirective)
})